import { CanDeactivateFn } from '@angular/router';
// import {inject} from "@angular/core";
// import {AnalyticsService} from "./analytics.service";

export const analyticsBeforeNavHookGuard: CanDeactivateFn<unknown> = async () => {

  // await inject(AnalyticsService).beforeNavigationHook(currentRoute, currentState, nextState);
  return true;
};
